import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 18v-12","key":"svg-0"}],["path",{"d":"M13 6l4 4l4 -4","key":"svg-1"}],["path",{"d":"M11 18l-7 -8l4 -4l4 4l-7 8","key":"svg-2"}]]

const IconAlphabetRunes = createReactComponent('outline', 'alphabet-runes', 'AlphabetRunes', __iconNode);

export default IconAlphabetRunes;